import http from '@/lib/http';

export default {
    createMedicalOder({ schedId, healthRecordId, diseaseDesc, already, annexList } = {}) {
        let data = new FormData();
        data.set('schedId', schedId);
        data.set('healthRecordId', healthRecordId);
        data.set('diseaseDesc', diseaseDesc);
        data.set('already', already);
        annexList.forEach(file => {
            data.append('file', file);
        });
        return http({
            url: `/paymentService/createMedicalOder`,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            data: data
        });
    },
    getWaitPayOrder(transactionRecordId) {
        return http({
            url: `/paymentService/getWaitPayOrder/${transactionRecordId}`
        });
    },
    getOrderPayStatus(transactionRecordId) {
        return http({
            url: `/paymentService/getOrderPayStatus/${transactionRecordId}`
        });
    },
    orderQuery(transactionRecordId) {
        return http({
            url: `/paymentService/orderQuery/${transactionRecordId}`
        });
    },
    cancelOrder(transactionRecordId) {
        return http({
            url: `/paymentService/cancelOrder/${transactionRecordId}`
        });
    },
    refundMedicalOrder({ transactionBillId, refundDesc } = {}) {
        return http({
            url: `/paymentService/refundMedicalOrder`,
            data: {
                transactionBillId
            }
        });
    },
    createMedicalDrugOder(data = {}) {
        return http({
            url: `/paymentService/createMedicalDrugOder`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        });
    },

}